import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import logo from "../asset/RadheLogo_1.png";

export default function AppNavbar({ contactInfo, socialLinks }) {
  const blue = "#0062A0";
  const magenta = "#E91E63";
  const location = useLocation();

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [location]);

  const renderIcon = (iconName, props = {}) => {
    const IconComponent = FaIcons[iconName];
    return IconComponent ? (
      <IconComponent {...props} />
    ) : (
      <FaIcons.FaQuestionCircle {...props} />
    );
  };

  const isActive = (path) =>
    location.pathname === path ? "active-link" : "text-dark";

  return (
    <header className="fixed-top shadow-sm">
      <div className="top-bar-gradient d-none d-lg-block">
        <Container>
          <Row className="align-items-center py-2">
            <Col md={8}>
              <div className="d-flex gap-4 small align-items-center">
                <div className="d-flex align-items-center text-white-50 me-2 border-end border-white border-opacity-25 pe-3">
                  {renderIcon("FaShieldAlt", { className: "me-2 text-white" })}
                  <span
                    className="fw-bold text-white small"
                    style={{ letterSpacing: "1px" }}
                  >
                    GOV. APPROVED
                  </span>
                </div>

                {contactInfo.map((info) => (
                  <a
                    key={info.id}
                    href={info.image_url}
                    className="text-white text-decoration-none d-flex align-items-center fw-light contact-hover"
                  >
                    {renderIcon(info.icon_name, {
                      className: "me-2 opacity-75",
                      style: { color: "#fff" },
                    })}
                    {info.subtitle}
                  </a>
                ))}
              </div>
            </Col>
            <Col md={4} className="text-end">
              <div className="d-flex justify-content-end gap-3 align-items-center">
                {socialLinks.map((social) => (
                  <a
                    key={social.id}
                    href={social.image_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white social-glass-icon"
                  >
                    {renderIcon(social.icon_name)}
                  </a>
                ))}
              </div>
            </Col>
          </Row>
        </Container>

        <style>
          {`
          .top-bar-gradient {
            background: linear-gradient(90deg, ${blue} 0%, #003d63 70%, ${magenta} 130%);
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            position: relative;
            z-index: 1050;
          }
          .contact-hover { transition: all 0.3s ease; opacity: 0.9; }
          .contact-hover:hover { opacity: 1; transform: translateY(-1px); text-shadow: 0 0 10px rgba(255,255,255,0.5); }
          .social-glass-icon {
            width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;
            background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(5px);
            border-radius: 50%; border: 1px solid rgba(255, 255, 255, 0.2);
            font-size: 0.8rem; transition: all 0.3s ease;
          }
          .social-glass-icon:hover {
            background: #fff; color: ${blue} !important;
            transform: rotate(360deg) scale(1.1); box-shadow: 0 0 15px rgba(255,255,255,0.4);
          }
        `}
        </style>
      </div>

      {/* --- MAIN NAVBAR --- */}
      <Navbar
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
        expand="lg"
        className="py-2 transparent-nav"
      >
        <Container>
          <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
            <img
              src={logo}
              height="70"
              width="110"
              className="d-inline-block align-top"
              alt="Logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav
              className="ms-auto align-items-center fw-bold text-uppercase"
              style={{ fontSize: "0.85rem", letterSpacing: "0.5px" }}
            >
              <Nav.Link
                as={Link}
                to="/"
                onClick={() => setExpanded(false)}
                className={`px-3 nav-hover-link ${isActive("/")}`}
              >
                Home
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => setExpanded(false)}
                className={`px-3 nav-hover-link ${isActive("/about")}`}
              >
                About Us
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/services"
                onClick={() => setExpanded(false)}
                className={`px-3 nav-hover-link ${isActive("/services")}`}
              >
                Services
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/projects"
                onClick={() => setExpanded(false)}
                className={`px-3 nav-hover-link ${isActive("/projects")}`}
              >
                Projects
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/gallery"
                onClick={() => setExpanded(false)}
                className={`px-3 nav-hover-link ${isActive("/gallery")}`}
              >
                Gallery
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/careers"
                onClick={() => setExpanded(false)}
                className={`px-3 nav-hover-link ${isActive("/careers")}`}
              >
                Careers
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => setExpanded(false)}
                className="px-3"
              >
                <button
                  className="btn text-white rounded-0 px-4 fw-bold text-uppercase shadow-sm"
                  style={{ backgroundColor: blue, border: "none" }}
                >
                  Inquiry
                </button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <style>
        {`
          .transparent-nav {
            background-color: rgba(255, 255, 255, 0.8) !important;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            transition: background-color 0.3s ease;
          }
          .nav-hover-link:hover { color: ${magenta} !important; }
          .active-link { color: ${blue} !important; }
          @media (min-width: 992px) {
            .nav-hover-link { position: relative; }
            .nav-hover-link::after {
              content: ''; position: absolute; width: 0; height: 2px;
              bottom: 5px; left: 15%; background-color: ${blue};
              transition: width 0.3s;
            }
            .nav-hover-link:hover::after, .active-link::after { width: 70% !important; }
          }
          @media (max-width: 991px) {
            .navbar-collapse { background-color: white; padding: 1rem; margin-top: 10px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
          }
        `}
      </style>
    </header>
  );
}
